import { AxiosResponse } from "axios";

import { IValidationConfig } from "../../../store/psaContactValidation/types";
import { apiPublicAxios } from "../../axios";
import { VERIFICATION_SETTINGS, PSA_CONTACT_VALIDATION } from "../../resources";

export const getValidationScreenConfig = (
  crmId: string
): Promise<AxiosResponse<IValidationConfig>> => {
  return apiPublicAxios.get<IValidationConfig>(
    `${VERIFICATION_SETTINGS}/getValidationScreenConfig/${crmId}`
  );
};

export const checkCode = (
  payload: { crmId: string; code: string ;}
): Promise<AxiosResponse<any>> => {
  return apiPublicAxios.post(`${PSA_CONTACT_VALIDATION}/check`, payload);
};
